<template>
  <layer-page typeTitle="多点线性核查"></layer-page>
</template>

<script>
import layerPage from '../components/layerPage.vue'
export default {
  components: {
    layerPage
  }
}
</script>
